/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { getGclidFromLocalStorage, getMsclkidFromLocalStorage } from '@zcode/legacy-local-storage'
import { register } from '@zcode/mixpanel'
import { localStorageSingleton } from '@zcode/nr-utils'

export const syncLocalStorageToMixpanel = () => {
  register({
    gclid: getGclidFromLocalStorage(localStorageSingleton) ?? '',
    msclkid: getMsclkidFromLocalStorage(localStorageSingleton) ?? '',
    utm_campaign: localStorageSingleton.get('_utm_campaign') ?? '',
    utm_content: localStorageSingleton.get('_utm_content') ?? '',
    utm_medium: localStorageSingleton.get('_utm_medium') ?? '',
    utm_source: localStorageSingleton.get('_utm_source') ?? '',
  })
}
